import React from 'react'
import {
    Container,
    ExplainText,
    Leftside,
    OptionsDiv,
    PaymentTypeDiv,
    Rightside,
    Type,
} from './styles'
import { RadioGroup } from '@headlessui/react'
import { Controller, UseFormReturn } from 'react-hook-form'
import classNames from 'classnames'
import TableParcelas from '../tableParcelas'
import { validateData } from '../../utils/date'

import { InputsFormStep2, LinkData } from '../../Pages/CobrancaCriar/interfaces'
import { TbCalendarTime } from 'react-icons/tb'
import { BiDollarCircle } from 'react-icons/bi'
import NumberFormat from 'react-number-format'
import { HiOutlineReceiptPercent } from 'react-icons/hi2'
import dayJs from '../../libs/dayjs'

interface Props {
    submitFormStep2(inputs: InputsFormStep2): void
    formStep2: UseFormReturn<InputsFormStep2, any>
    linkData: LinkData
}

export default function Step2({
    submitFormStep2,
    linkData,
    formStep2: {
        control,
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
    },
}: Props) {
    return (
        <Container className="flex flex-col gap-y-10 2xl:flex-row w-full justify-between 2xl:gap-x-16 col-span-2">
            {/* <h3 >Como o seu cliente poderá pagar?</h3> */}

            <Leftside className="md:min-w-max">
                <PaymentTypeDiv>
                    <Controller
                        defaultValue={0}
                        name="tipoLink"
                        control={control}
                        rules={{
                            required: 'Escolha o tipo da cobrança',
                        }}
                        render={({ field: { value, ...field } }) => (
                            <RadioGroup
                                {...field}
                                defaultValue={0}
                                value={value}
                            >
                                <RadioGroup.Label className="text-2xl text-gray-900">
                                    Como o seu cliente poderá pagar?
                                </RadioGroup.Label>
                                <OptionsDiv>
                                    <RadioGroup.Option value={0}>
                                        {({ checked }) => (
                                            <Type
                                                className={classNames(
                                                    'flex items-center justify-center rounded-lg focus:ring-2 focus:ring-blue-500 focus:ring-offset-blue-200 focus:ring-offset-2 focus:outline-none',
                                                    {
                                                        'border-transparent shadow-md outline-none ring-2 ring-blue-500 bg-blue-50':
                                                            checked,
                                                    },
                                                    {
                                                        'hover:border-blue-100 border border-gray-300':
                                                            !checked,
                                                    }
                                                )}
                                            >
                                                <BiDollarCircle
                                                    className={classNames(
                                                        'text-gray-700'
                                                    )}
                                                />
                                                <p
                                                    className={classNames(
                                                        'text-base',
                                                        {
                                                            'text-blue-600':
                                                                checked,
                                                        }
                                                    )}
                                                >
                                                    À vista
                                                    <br /> ou parcelado{' '}
                                                </p>
                                            </Type>
                                        )}
                                    </RadioGroup.Option>
                                    <RadioGroup.Option value={1}>
                                        {({ checked }) => (
                                            <Type
                                                className={classNames(
                                                    'flex items-center justify-center rounded-lg focus:ring-2 focus:ring-blue-500 focus:ring-offset-blue-200 focus:ring-offset-2 focus:outline-none',
                                                    {
                                                        'border-transparent shadow-md outline-none ring-2 ring-blue-500 bg-blue-50':
                                                            checked,
                                                    },
                                                    {
                                                        'hover:border-blue-100 border border-gray-300':
                                                            !checked,
                                                    }
                                                )}
                                            >
                                                <TbCalendarTime
                                                    className={classNames(
                                                        'text-gray-700'
                                                    )}
                                                />
                                                <p
                                                    className={classNames(
                                                        'text-base',
                                                        {
                                                            'text-blue-600':
                                                                checked,
                                                        }
                                                    )}
                                                >
                                                    Recorrência
                                                </p>
                                            </Type>
                                        )}
                                    </RadioGroup.Option>
                                    <RadioGroup.Option value={2}>
                                        {({ checked }) => (
                                            <Type
                                                className={classNames(
                                                    'flex items-center justify-center rounded-lg focus:ring-2 focus:ring-blue-500 focus:ring-offset-blue-200 focus:ring-offset-2 focus:outline-none',
                                                    {
                                                        'border-transparent shadow-md outline-none ring-2 ring-blue-500 bg-blue-50':
                                                            checked,
                                                    },
                                                    {
                                                        'hover:border-blue-100 border border-gray-300':
                                                            !checked,
                                                    }
                                                )}
                                            >
                                                <HiOutlineReceiptPercent
                                                    className={classNames(
                                                        'text-gray-700'
                                                    )}
                                                    // size={36}
                                                />
                                                <p
                                                    className={classNames(
                                                        'text-base',
                                                        {
                                                            'text-blue-600':
                                                                checked,
                                                        }
                                                    )}
                                                >
                                                    Porcentagem da agenda diária
                                                </p>
                                            </Type>
                                        )}
                                    </RadioGroup.Option>
                                </OptionsDiv>
                            </RadioGroup>
                        )}
                    />

                    {errors.tipoLink && errors.tipoLink.type === 'required' && (
                        <span className="text-red-500 text-sm">
                            {errors.tipoLink.message}
                        </span>
                    )}
                </PaymentTypeDiv>

                <ExplainText className="">
                    {/* {watch('tipoLink') === 0
                        ? 'O valor será cobrado apenas uma vez, podendo ser parcelado conforme definido.'
                        : `Cobranças recorrentes com frequência personalizada, todas com o valor de ${Number(
                              linkData.valor
                          ).toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                          })}`} */}

                    {watch('tipoLink') === 0 &&
                        'O valor será cobrado apenas uma vez, podendo ser parcelado conforme definido.'}

                    {watch('tipoLink') === 1 &&
                        `Cobranças recorrentes com frequência personalizada, todas com o valor de ${Number(
                            linkData.valor
                        ).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}`}

                    {watch('tipoLink') === 2 &&
                        `Será cobrado uma porcetagem da agenda diária até o valor selecionado (${Number(
                            linkData.valor
                        ).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}) ser atingido. Defina também o periodo em que você quer receber esse valor. Essa é uma boa opção para evitar comprometer a agenda do pagador em um dia específico.`}
                </ExplainText>
                <div className="flex flex-col gap-2 sm:flex-row sm:justify-between sm:items-start sm:gap-4 max-w-md">
                    {Number(watch('tipoLink')) === 0 && (
                        <div className="block mb-2 sm:mb-0">
                            <label
                                htmlFor="quantParcela"
                                className="text-gray-700 text-sm mb-2 block"
                            >
                                Quantidade de parcelas:{' '}
                            </label>
                            <select
                                defaultValue={1}
                                {...register('quantParcelas')}
                                className="appearance-none rounded-lg flex-1 border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                                id="quantParcela"
                            >
                                <option
                                    className="block py-2 px-4 bg-white hover:bg-blue-600 cursor-pointer"
                                    value={1}
                                >
                                    À vista
                                </option>
                                <option
                                    className="py-2 px-4 bg-white hover:bg-blue-600 cursor-pointer"
                                    value={2}
                                >
                                    Em até 2x
                                </option>
                                <option
                                    className="py-2 px-4 bg-white hover:bg-blue-600"
                                    value={3}
                                >
                                    Em até 3x
                                </option>
                                <option
                                    className="py-2 px-4 bg-white hover:bg-blue-600"
                                    value={4}
                                >
                                    Em até 4x
                                </option>
                                <option className="py-2 px-4" value={5}>
                                    Em até 5x
                                </option>
                                <option className="py-2 px-4" value={6}>
                                    Em até 6x
                                </option>
                                <option className="py-2 px-4" value={7}>
                                    Em até 7x
                                </option>
                                <option className="py-2 px-4" value={8}>
                                    Em até 8x
                                </option>
                                <option className="py-2 px-4" value={9}>
                                    Em até 9x
                                </option>
                                <option className="py-2 px-4" value={10}>
                                    Em até 10x
                                </option>
                            </select>
                        </div>
                    )}
                    {Number(watch('tipoLink')) === 1 && (
                        <div className="block mb-2 sm:mb-0">
                            <label
                                htmlFor="frequenciaCobranca"
                                className="text-gray-700 text-sm mb-2 block"
                            >
                                Frequência da cobrança:{' '}
                            </label>
                            <select
                                defaultValue={1}
                                {...register('frequenciaCobranca')}
                                className="appearance-none rounded-lg flex-1 border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                                id="frequenciaCobranca"
                            >
                                <option value={1}>Mensal</option>
                                <option value={3}>Trimestral</option>
                                <option value={6}>Semestral</option>
                                <option value={12}>Anual</option>
                            </select>
                        </div>
                    )}

                    {Number(watch('tipoLink')) === 2 && (
                        <div className="relative w-full">
                            <label
                                htmlFor="value"
                                className="text-gray-700 text-sm label block mb-2"
                            >
                                Porcentagem
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <div className="flex relative mt-1">
                                <span className="rounded-l-md inline-flex items-center px-3 border-t bg-white border-l border-b border-gray-300 text-gray-500 shadow-sm text-sm">
                                    %
                                </span>

                                <Controller
                                    defaultValue=""
                                    name="porcentagemSobreAgenda"
                                    control={control}
                                    rules={{
                                        required: 'O campo valor é obrigatório',
                                        validate: (value: any) =>
                                            Number(value) > 0 &&
                                            Number(value) <= 100,
                                    }}
                                    render={({
                                        field: {
                                            value,
                                            onChange,
                                            ref,
                                            ...field
                                        },
                                    }) => (
                                        <NumberFormat
                                            {...field}
                                            value={value}
                                            className={classNames(
                                                'rounded-r-lg appearance-none border border-gray-300 flex-none w-32 py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent',
                                                {
                                                    'ring-red-500 ring-2':
                                                        errors.porcentagemSobreAgenda,
                                                }
                                            )}
                                            id="porcentagemSobreAgenda"
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            thousandsGroupStyle="thousand"
                                            fixedDecimalScale
                                            decimalScale={2}
                                            allowNegative={false}
                                            placeholder="Ex: 10"
                                            prefix={''}
                                            onValueChange={({
                                                formattedValue,
                                                floatValue,
                                            }) => {
                                                onChange(floatValue || '')
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            {errors.porcentagemSobreAgenda &&
                                errors.porcentagemSobreAgenda.type ===
                                    'required' && (
                                    <span className="text-red-500 text-sm">
                                        {errors.porcentagemSobreAgenda.message}
                                    </span>
                                )}
                            {errors.porcentagemSobreAgenda &&
                                errors.porcentagemSobreAgenda.type ===
                                    'validate' && (
                                    <span className="text-red-500 text-sm">
                                        Valor inválido
                                    </span>
                                )}
                        </div>
                    )}

                    <div className="">
                        <label
                            htmlFor="data"
                            className="text-gray-700 text-sm mb-2 block"
                        >
                            {/* {Number(watch('tipoLink')) === 0 &&
                                Number(watch('quantParcelas')) === 1
                                    ? 'Vencimento da cobrança'
                                    : Number(watch('tipoLink')) === 0
                                    ? 'Vencimento da 1ª parcela'
                                    : 'Vencimento da 1ª cobrança'} */}
                            {Number(watch('tipoLink')) === 0 &&
                                Number(watch('quantParcelas')) === 1 &&
                                'Vencimento da cobrança'}
                            {Number(watch('tipoLink')) === 0 &&
                                Number(watch('quantParcelas')) !== 1 &&
                                'Vencimento da 1ª parcela'}
                            {Number(watch('tipoLink')) === 1 &&
                                'Vencimento da 1ª cobrança'}
                            {Number(watch('tipoLink')) === 2 && 'A partir de:'}
                        </label>
                        <input
                            defaultValue=""
                            id="data"
                            {...register('dataLiquidacao', {
                                required: false,
                                validate: (value) => validateData(value),
                            })}
                            className="w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm py-2 px-4 focus:border-transparent"
                            type="date"
                        />
                        {errors.dataLiquidacao &&
                            errors.dataLiquidacao.type === 'required' && (
                                <span className="text-red-500 text-sm">
                                    Data inválida
                                </span>
                            )}
                        {errors.dataLiquidacao &&
                            errors.dataLiquidacao.type === 'validate' && (
                                <span className="text-red-500 text-sm">
                                    Data inválida
                                </span>
                            )}
                    </div>

                    {Number(watch('tipoLink')) === 2 && (
                        <div className="">
                            <label
                                htmlFor="dataLiquidacaoFim"
                                className="text-gray-700 text-sm mb-2 block"
                            >
                                Até:
                            </label>
                            <input
                                defaultValue=""
                                id="dataLiquidacaoFim"
                                {...register('dataLiquidacaoFinal', {
                                    required: false,
                                    validate: (value) => {
                                        const dataLiquidacao =
                                            watch('dataLiquidacao')
                                        if (value) {
                                            const isAfterThan = dayJs(
                                                value
                                            ).isAfter(dayJs(dataLiquidacao))

                                            const dayOfWeek = dayJs(value).day()
                                            const isWeekday =
                                                dayOfWeek !== 0 &&
                                                dayOfWeek !== 6

                                            return isAfterThan && isWeekday
                                        }
                                        return false
                                    },
                                })}
                                className="w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm py-2 px-4 focus:border-transparent"
                                type="date"
                            />

                            {errors.dataLiquidacaoFinal &&
                                errors.dataLiquidacaoFinal.type ===
                                    'required' && (
                                    <span className="text-red-500 text-sm">
                                        Data inválida
                                    </span>
                                )}
                            {errors.dataLiquidacaoFinal &&
                                errors.dataLiquidacaoFinal.type ===
                                    'validate' && (
                                    <span className="text-red-500 text-sm">
                                        A data final precisa ser maior que a
                                        inicial e não pode ser finais de semana.
                                    </span>
                                )}
                        </div>
                    )}
                </div>
            </Leftside>

            {/* {renderSelect()} */}
            <Rightside className="max-w-lg">
                {/* <p className='text-2xl text-gray-900 mb-4'>Valor liquido a receber R$ 100,00</p> */}
                {linkData.valor !== 0 &&
                    linkData.valor &&
                    watch('tipoLink') === 0 && (
                        <TableParcelas
                            data_Liquidacao={watch('dataLiquidacao')}
                            valueLink={Number(linkData.valor)}
                            quantParcelas={Number(watch('quantParcelas'))}
                        />
                    )}
            </Rightside>
        </Container>
    )
}
